pageId = 'page-attachments'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  if $page.is('[data-archived], [data-deleted]')
    $page.find('.btn-upload-file').remove()
  else
    tower.initFileUpload()
    tower.initFileDnD $page

  $filesView = $page.find('.files-view')

  simple.filedrop(
    el: if $filesView.is(':visible') then $filesView else $page
    hints: '拖拽到这里上传'
  ).on 'drop', (e, files) ->
    $btn = $('.btn-upload-file')
    uploader = $btn.data('uploader')

    unless tower.isScreenView($btn)
      simple.scrollTo target: $btn

    if files
      $.each files, (i, file) ->
        uploader.upload file

  tower.initFileViews()
